package dev.lingvo.site.api

import dev.lingvo.shared.StoreAllowedAppsRequest
import dev.lingvo.shared.StoreAppChoiceDto
import dev.lingvo.shared.StoreConnectionCheckDto
import dev.lingvo.shared.StoreConnectionCheckRequest
import dev.lingvo.shared.StoreConnectionDto

/** Wizard operations use the same transport, actor identity and encoded segments as ApiClient. */
suspend fun ApiClient.storeConnectionApps(orgSlug: String, connectionId: String): List<StoreAppChoiceDto> =
    jsonRequest("GET", "/orgs/${segment(orgSlug)}/store-connections/${segment(connectionId)}/apps")

suspend fun ApiClient.checkStoreConnection(orgSlug: String, connectionId: String, appRef: String): StoreConnectionCheckDto =
    jsonRequest("POST", "/orgs/${segment(orgSlug)}/store-connections/${segment(connectionId)}/check", StoreConnectionCheckRequest(appRef))

suspend fun ApiClient.allowStoreConnectionApps(orgSlug: String, connectionId: String, appRefs: List<String>): StoreConnectionDto =
    jsonRequest("PUT", "/orgs/${segment(orgSlug)}/store-connections/${segment(connectionId)}/apps", StoreAllowedAppsRequest(appRefs))
